import { Divider, Flex } from "antd";
import { ItemInfo } from "components";
import { routes } from "constants/routes";

import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createBeneficiary } from "services";
import { useStores } from "stores";
import { CustomButton, Skeleton } from "ui";
import { dateFormat, getPhone, requestWithNotify, useRequestWithNotify } from "utils";
import { CompanyInfo } from "./CompanyInfo";
import { COMPANY_TYPES } from "interfaces";
import { IpInfo } from "./IpInfo";

const CreateBeneficiaryModalSkeleton = () => {
  return (
    <Flex vertical gap="small">
      {Array.from({ length: 9 }).map((_, index) => (
        <Skeleton key={index} width="100%" height="19px" />
      ))}
      <Flex justify="space-between" gap="small" style={{ marginTop: "10px" }}>
        <Skeleton width="100%" height="40px" />
        <Skeleton width="100%" height="40px" />
      </Flex>
    </Flex>
  );
};

export const CreateBeneficiaryModal = observer(() => {
  const { companyCard, actionModals } = useStores();
  const { openNotification } = useNotificationContext();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const createBeneficiaryHandler = async () => {
    if (!companyCard.card.id) return null;

    setLoading(true);

    try {
      const res = await requestWithNotify({
        fetchFn: () => createBeneficiary({ id: companyCard.card.id }),
        openNotification: openNotification,
        successMsg: "Бенефициар успешно зарегистрирован",
        showErrorNotification: true,
      });

      if (res.result) {
        setLoading(true);
        await requestWithNotify({
          fetchFn: () => companyCard.fetchCompanyCardById(companyCard.card.id),
          openNotification: openNotification,
          delay: 5000,
        });
      }
    } finally {
      setLoading(false);
      closeModalHandler();
    }
  };

  const disabledBtnForCompany =
    !companyCard.card.contractNumber ||
    !companyCard.card.contractDate ||
    !companyCard.card.companyRegistrationNumber ||
    !companyCard.card.inn ||
    !companyCard.card.kpp ||
    !companyCard.card.address ||
    !companyCard.card.email ||
    !companyCard.card.phone;

  const disabledBtnForIp =
    !companyCard.card.contractNumber ||
    !companyCard.card.contractDate ||
    !companyCard.card.companyRegistrationNumber ||
    !companyCard.card.identificationDocSeria ||
    !companyCard.card.identificationDocNumber ||
    !companyCard.card.identificationDocIssuer ||
    !companyCard.card.identificationDocIssueDate ||
    !companyCard.card.identificationDocIssuerCode ||
    !companyCard.card.postAddress ||
    !companyCard.card.inn ||
    !companyCard.card.name ||
    !companyCard.card.surname ||
    !companyCard.card.birthDate ||
    !companyCard.card.email ||
    !companyCard.card.phone;

  const disabled = companyCard.card.type === COMPANY_TYPES.COMPANY ? disabledBtnForCompany : disabledBtnForIp;

  const addCompanyDataHandler = () => {
    navigate(`/${routes.companies}/edit/${companyCard.card.id}`);
    closeModalHandler();
  };

  const closeModalHandler = () => {
    actionModals.closeAll();
  };

  return companyCard.fetchStatus === "fetching" ? (
    <CreateBeneficiaryModalSkeleton />
  ) : (
    <Flex vertical gap="24px">
      {companyCard.card.type === COMPANY_TYPES.COMPANY ? (
        <CompanyInfo companyCard={companyCard.card} />
      ) : (
        <IpInfo companyCard={companyCard.card} />
      )}
      <Divider className="margin-top-none margin-bottom-none" />
      <Flex justify="space-between" gap="small" vertical>
        <CustomButton
          onClick={createBeneficiaryHandler}
          disabled={disabled}
          loading={loading}
          tooltip={disabled ? "Не хватает данных для регистрации бенефициара" : undefined}
          variant="outlined"
          className="full-width"
        >
          Зарегистрировать бенефициара
        </CustomButton>
        <CustomButton onClick={addCompanyDataHandler} loading={loading} className="full-width">
          Обновить данные компании
        </CustomButton>
      </Flex>
    </Flex>
  );
});
